export * from '@fluentui/font-icons-mdl2';
